import { render, staticRenderFns } from "./control-head.vue?vue&type=template&id=78b4e8c6"
import script from "./control-head.vue?vue&type=script&lang=js"
export * from "./control-head.vue?vue&type=script&lang=js"
import style0 from "./control-head.vue?vue&type=style&index=0&id=78b4e8c6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b4e8c6')) {
      api.createRecord('78b4e8c6', component.options)
    } else {
      api.reload('78b4e8c6', component.options)
    }
    module.hot.accept("./control-head.vue?vue&type=template&id=78b4e8c6", function () {
      api.rerender('78b4e8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/control-head.vue"
export default component.exports